import { ACTIVITY_TYPES } from '../activityTypes.js';
import { isMuted, popBurst, unlockAudio } from './sfxCore.js';

/** @type {Map<string, string>} */
const fileUrlByType = new Map();

/** @type {Map<string, HTMLAudioElement>} */
const fileCache = new Map();

/** Root pitch (Hz) per activity — arcade pop colour (higher = sharper). */
const POP_ROOT_BY_TYPE = Object.freeze({
    [ACTIVITY_TYPES.PHONE_CALL]: 760,
    [ACTIVITY_TYPES.CHECK_IN]: 800,
    [ACTIVITY_TYPES.VIDEO_CHECK_IN]: 840,
    [ACTIVITY_TYPES.FAST_CHECK_IN]: 900,
    [ACTIVITY_TYPES.EMAIL]: 760,
    [ACTIVITY_TYPES.VIDEO_CALL]: 820,
    [ACTIVITY_TYPES.WHATSAPP]: 940,
});

const PROCEDURAL_BY_TYPE = Object.freeze(
    Object.fromEntries(
        Object.entries(POP_ROOT_BY_TYPE).map(([type, rootHz]) => [
            type,
            () => popBurst({ rootHz, gain: 0.11 }),
        ]),
    ),
);

function playFile(url) {
    if (isMuted()) return;
    unlockAudio();

    let audio = fileCache.get(url);
    if (!audio) {
        audio = new Audio(url);
        audio.preload = 'auto';
        fileCache.set(url, audio);
    }

    audio.currentTime = 0;
    audio.play().catch(() => {});
}

function playProcedural(activityType) {
    const play = PROCEDURAL_BY_TYPE[activityType] || PROCEDURAL_BY_TYPE[ACTIVITY_TYPES.EMAIL];
    play();
}

/**
 * Register a URL to replace the procedural sound for an activity type.
 * @param {string} activityType
 * @param {string} url
 */
export function registerActivitySoundAsset(activityType, url) {
    if (!activityType || !url) return;
    fileUrlByType.set(activityType, url);
}

export function clearActivitySoundAsset(activityType) {
    fileUrlByType.delete(activityType);
}

export function getActivitySoundAsset(activityType) {
    return fileUrlByType.get(activityType) || null;
}

/** @returns {string[]} */
export function getActivityTypesWithProceduralSound() {
    return Object.keys(PROCEDURAL_BY_TYPE);
}

/**
 * Play the sound for an activity card hit.
 * @param {string} activityType
 */
export function playActivitySound(activityType) {
    if (isMuted()) return;

    unlockAudio();

    const fileUrl = fileUrlByType.get(activityType);
    if (fileUrl) {
        playFile(fileUrl);
        return;
    }

    playProcedural(activityType);
}
